<template>
    <div>
        <default-tools
                :header-title="`Tools`"
                :button-title="`Create Horoscope`"
                :button-icon="`fa fa-plus`"
                :button-color="`primary`"
                :button-event="showModalCreate"
                :modal-id="`createHoroscopeAnnual`"
                button
                backBtn

                search-by-items
                :search-by-name="`Horoscope by Page`"
                :table-columns="tableColumns"
                limit
                @filtered="filterData"
                @limit="selectedLimit = $event"
                @selectedTableColumns="selectedTableColumns = $event"
        />

        <b-card>
            <template slot="header">
                <card-header
                        :header-title="`Horoscope Annuals`"
                        backBtn
                />
            </template>

            <Loader :loading="loading"/>

            <b-table
                    bordered
                    responsive
                    hover
                    striped
                    :items="tableItems"
                    :fields="fields"
                    class="table-with-translations"
                    @row-clicked="showModalDetail"
            >
                <template slot="zodiacSign" slot-scope="data">
                    {{ data.value.label }}
                </template>

                <template slot="type" slot-scope="data">
                    {{data.value.label}}
                </template>

                <template slot="translations" slot-scope="data">
                    <b-list-group>
                        <b-list-group-item
                                class="flex-column align-items-start"
                                v-for="translation in data.value"
                                :key="`${translation.locale}${translation.id}`"
                        >
                            <div class="d-flex w-100 justify-content-between">
                                <small>{{translation.locale}}</small>
                            </div>
                            <p class="mb-1">
                                {{translation.description}}
                            </p>
                        </b-list-group-item>
                    </b-list-group>
                </template>

                <template slot="bottom-row">
                    <table-empty :items="tableItems" :columnsItem="fields"/>
                </template>
            </b-table>

            <Pagination
                    v-if="totalHoroscopeAnnuals && !filtered"
                    :total-items="totalHoroscopeAnnuals"
                    :limit="Number(selectedLimit)"
                    :current-page="Number(currentPage)"
                    @currentPage="currentPage = $event"
            />
        </b-card>

        <HoroscopeAnnualCreate
                :modal-id="`createHoroscopeAnnual`"
                :show-modal="createHoroscopeAnnualForm"
                :horoscope-types="horoscopeTypes"
                :zodiac-signs="zodiacSigns"
                @closeModalHoroscopeAnnual="hideModalCreate"
                @UpdateHoroscopeAnnual="getHoroscopeAnnualsList"
        />


        <HoroscopeAnnualDetail
                :modal-id="`detailHoroscopeAnnual`"
                :show-modal="detailHoroscopeAnnualForm"
                :horoscope-annual-data="selectedHoroscopeAnnual"
                :horoscope-types="horoscopeTypes"
                :zodiac-signs="zodiacSigns"
                @closeModalHoroscopeAnnual="hideModalDetail"
                @UpdateHoroscopeAnnual="getHoroscopeAnnualsList"
        />


    </div>
</template>

<script>
    import CardHeader from "@/components/Includes/CardHeader/CardHeader.vue";
    import TableEmpty from '@/components/Includes/Table/TableFooter/TableEmpty/TableEmpty.vue';
    import cleanData from "@/libs/cleanData";
    import cloneObject from "@/libs/cloneObject";
    import getParamQuery from "@/libs/getParamQuery";
    import getQueryData from "@/libs/getQueryData";
    import getTableColumns from "@/libs/getTableColumns";
    import isEmpty from "@/libs/isEmpty";
    import searchByTable from "@/libs/searchQuery/searchByTable";
    import {transformMultiSelect} from "@/libs/transformData/transformMultiSelect";
    import Multiselect from 'vue-multiselect';

    import DefaultTools from '@/components/Includes/DefaultTools/DefaultTools.vue';
    import Loader from '@/components/Includes/Loader/Loader.vue';
    import Pagination from '@/components/Includes/Pagination/Pagination.vue';
    import {Switch as cSwitch} from '@coreui/vue';
    import { HOROSCOPES_ANNUAL_GET_HOROSCOPES, HOROSCOPES_ANNUAL_LOAD_HOROSCOPES, HOROSCOPES_TYPES_GET_TYPES, HOROSCOPES_TYPES_LOAD_TYPES } from '@/store/constants';

    import HoroscopeAnnualCreate
        from '@/components/Horoscopes/HoroscopeAnnual/HoroscopeAnnualCreate.vue';
    import HoroscopeAnnualDetail
        from '@/components/Horoscopes/HoroscopeAnnual/HoroscopeAnnualDetail.vue';

    export default {
        name: 'HoroscopeAnnualsList',
        components: {
            DefaultTools,
            Loader,
            Pagination,
            HoroscopeAnnualCreate,
            HoroscopeAnnualDetail,
            TableEmpty,
            Multiselect,
            CardHeader,
            cSwitch
        },
        data() {
            return {
                loading: true,
                createHoroscopeAnnualForm: false,
                detailHoroscopeAnnualForm: false,
                zodiacSigns: [],
                horoscopeTypes: [],
                horoscopeAnnuals: [],
                selectedHoroscopeAnnual: null,
                filtered: null,
                selectedTableColumns: [],
                totalHoroscopeAnnuals: null,
                currentPage: 1,
                selectedLimit: '100',

            }
        },
        methods: {
            showModalDetail(horoscopeAnnual) {
                this.detailHoroscopeAnnualForm = !this.detailHoroscopeAnnualForm;
                this.selectedHoroscopeAnnual = cloneObject(horoscopeAnnual);
            },

            hideModalDetail() {
                this.detailHoroscopeAnnualForm = false;
                this.selectedHoroscopeAnnual = null;
            },

            showModalCreate() {
                this.createHoroscopeAnnualForm = !this.createHoroscopeAnnualForm
            },

            hideModalCreate() {
                this.createHoroscopeAnnualForm = false;
            },

            filterData(query) { // Method for search tool
                this.filtered = searchByTable(query, this.horoscopeAnnuals)
            },

            queryValue() {
                if (this.payloadQuery.query && this.payloadQuery.query.length > 0) {
                    this.readQueryValue();
                } else {
                    this.writeQueryValue();
                    this.readQueryValue();
                }
            },

            readQueryValue() {
                const queryData = getQueryData(this.$route.query);

                queryData.map(({key, value}) => {
                    switch (key) {
                        case 'page': {
                            this.currentPage = value;
                            break;
                        }
                        case 'limit': {
                            this.selectedLimit = value;
                            break;
                        }
                        default:
                            break;
                    }
                });
            },

            writeQueryValue() {
                const queryData = {
                    page: this.currentPage,
                    limit: this.selectedLimit
                };

                this.$router.replace({
                    name: this.$route.name || undefined,
                    query: cleanData(queryData)
                });
            },

            async getHoroscopeAnnualsList() {
                try {
                    this.loading = true;
                    this.queryValue();

                    this.totalHoroscopeAnnuals = await this.$store.dispatch(HOROSCOPES_ANNUAL_LOAD_HOROSCOPES, this.payloadQuery);
                    this.horoscopeAnnuals = this.getHoroscopeAnnuals;

                    this.checkZodiacSign();
                    this.checkType();
                    this.loading = false;

                } catch (error) {
                    throw new Error(error);
                }
            },

            checkZodiacSign() {
                this.horoscopeAnnuals.map((item) => {
                    if (this.zodiacSigns) {
                        this.zodiacSigns.forEach((zodiacSign) => {
                            if (item.zodiacSign === zodiacSign.value) {
                                item.zodiacSign = zodiacSign
                            }
                        });
                    }
                });
            },

            checkType() {
                this.horoscopeAnnuals.map((item) => {
                    if (this.horoscopeTypes) {
                        this.horoscopeTypes.forEach((type) => {
                            if (item.type === type.value) {
                                item.type = type
                            }
                        });
                    }
                });
            },

            async getRelations() {
                this.zodiacSigns = transformMultiSelect(this.getZodiacSigns, 'title', 'id');
                if (isEmpty(this.getZodiacSigns)) {
                    await this.$store.dispatch('zodiacSignsList', {query: '?pagination=false'});
                    this.zodiacSigns = transformMultiSelect(this.getZodiacSigns, 'title', 'id');
                }

                this.horoscopeTypes = transformMultiSelect(this.getHoroscopeTypes, 'title', 'id');
                if (isEmpty(this.getHoroscopeTypes)) {
                    await this.$store.dispatch(HOROSCOPES_TYPES_LOAD_TYPES, {query: '?pagination=false'});
                    this.horoscopeTypes = transformMultiSelect(this.getHoroscopeTypes, 'title', 'id');
                }
            },


        },
        computed: {
            tableItems() {
                return this.filtered ? this.filtered : this.horoscopeAnnuals;
            },

            tableColumns() {
                if (this.tableItems) {
                    return getTableColumns(this.horoscopeAnnuals, true, ['id']);
                }
            },

            fields() {
                if (this.tableColumns) {
                    const columnsIds = this.selectedTableColumns.map((el) => el.value);
                    return this.tableColumns.filter((el) => columnsIds.includes(el.key));
                } else {
                    return this.tableColumns;
                }
            },

            payloadQuery() {
                return {
                    ...getParamQuery(this.$route),
                    metaData: true
                }
            },

            getHoroscopeAnnuals() {
                return this.$store.getters[HOROSCOPES_ANNUAL_GET_HOROSCOPES];
            },

            getHoroscopeTypes() {
                return this.$store.getters[HOROSCOPES_TYPES_GET_TYPES];
            },

            getZodiacSigns() {
                return this.$store.getters.getZodiacSigns();
            }
        },
        watch: {
            selectedLimit() {
                this.writeQueryValue();
                this.getHoroscopeAnnualsList();
            },

            currentPage() {
                this.writeQueryValue();
                this.getHoroscopeAnnualsList();
            }
        },
        async mounted() {
            try {
                await this.getRelations();
                await this.getHoroscopeAnnualsList();
            } catch (error) {
                throw new Error(error);
            }
        },
    }

</script>